import React, { lazy } from "react";
import UIDs from "../../UIDs";

const AccountDeactivePage = (lazy(() => import("../../screens/account/AccountDeactivate")));
const PasswordResetPage = (lazy(() => import("../../screens/account/PasswordReset")));
const LoginScreen = lazy(() => import("../../screens/account/LoginScreen"));
const SignUpPage = lazy(() => import("../../screens/account/SignUp"));
const VerifyEmailPage = lazy(() => import("../../screens/account/VerifyEmail"));
const WelcomePage = lazy(() => import("../../screens/account/Welcome"));

export const accountRoutes = [
    {
        path: "/register",
        uid: UIDs.screens.account.register,
        layout: "/account",
        element: SignUpPage ,
    },
    {
        path: "/login",
        uid: UIDs.screens.account.login,
        layout: "/account",
        element: LoginScreen ,
    },
    {
        path: "/welcome",
        uid: UIDs.screens.auth.welcome,
        layout: "/account",
        element: WelcomePage ,
    },
    {
        path: "/verifyEmail",
        uid: UIDs.screens.auth.verifyEmail,
        layout: "/account",
        element: VerifyEmailPage ,
    },
    {
        path: "/passwordReset",
        uid: UIDs.screens.auth.passwordReset,
        layout: "/account",
        element: PasswordResetPage ,
    },
    {
        path: "/accountDelete",
        uid: UIDs.screens.auth.accountDelete,
        layout: "/account",
        element: AccountDeactivePage ,
    },
]; 
